import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UserService} from '../services/user.service';
import {Message, MessageService} from 'primeng/api';
import {ProfileService} from '../services/profile.service';
import {NgxOtpInputComponent} from 'ngx-otp-input';
import {HelperService} from '../services/helper.service';

@Component({
  selector: 'app-phone-verification',
  templateUrl: './phone-verification.component.html',
  styleUrls: ['./phone-verification.component.scss']
})
export class PhoneVerificationComponent implements OnInit {
  private userId: string;
  public isPhoneProvided = false;
  public loading = false;
  public codeSent = false;
  public isMobile = false;
  public isSending = false;
  public isVerifying = false;
  public verificationMessages: Message[] = [];
  public otpCode: string[];
  public newPhoneNumber: number;
  public newPhonePrefix: string;
  public countriesData: any;

  @Input() displayPhoneVerification = false;
  @Input() phoneToVerify: string;
  @Output() dialogClosed = new EventEmitter<boolean>();

  @ViewChild('otpInput') otpInput: NgxOtpInputComponent;

  constructor(private userService: UserService,
              private helperService: HelperService,
              private profileService: ProfileService,
              private messageService: MessageService) {
  }

  ngOnInit() {
    this.otpCode = [];
    this.isMobile = this.helperService.isMobile();
    this.userId = this.profileService.getUserData().id;
    this.isPhoneProvided = this.phoneToVerify
        && (this.phoneToVerify.length < 20 && this.phoneToVerify.length > 8)
        && this.phoneToVerify !== '306900000000';
    this.countriesData = this.helperService.getCountriesData();

    const userCountry = this.profileService.getUserData().address.country;
    if (userCountry) {
        this.newPhonePrefix = this.countriesData.find(country => country.label === userCountry).phone;
    }
  }

  dialogClosing() {
      this.codeSent = false;
      this.isSending = false;
      this.isVerifying = false;
      this.verificationMessages = [];
      this.otpCode = [];
      this.dialogClosed.emit(true);
  }

  startPhoneVerification() {
    this.isSending = true;
    this.userService.verifyPhone(this.userId).then(
        () => {
          this.codeSent = true;
          this.isSending = false;
          this.verificationMessages = [{ severity: 'info', summary: 'Code sent' }];
        },
        (err) => {
          this.isSending = false;
          this.verificationMessages = [{ severity: 'error', detail: err || err.error.message }];
        }
    );
  }

  submitPhoneCode(otpCode: string) {
    this.isVerifying = true;
    this.userService.verifyOtpToken(this.userId, otpCode).then(
        (data) => {
          this.profileService.setUserData(data);
          this.verificationMessages = [{ severity: 'success', summary: 'Phone verified!' }];
          this.isVerifying = false;
          this.displayPhoneVerification = false;
          this.messageService.add({
              key: 'globalToast', severity: 'success', summary: 'Verified', detail: 'Your phone was verified!', life: 3000
          });
          this.dialogClosed.emit(true);
        },
        (err) => {
          this.otpCode = [];
          this.otpInput.reset();
          this.isVerifying = false;
          this.verificationMessages = [{ severity: 'error', detail: err.error.message }];
        }
    );
  }

  saveNewPhoneNumber() {
      this.loading = true;
      const editObject = {
          countryCode: this.newPhonePrefix.toString(),
          phoneNumber: this.newPhoneNumber,
      };
      this.userService.editUser( this.userId, editObject)
          .then((data) => {
              this.profileService.setUserData(data);
              this.messageService.add({
                  key: 'globalToast', severity: 'success', summary: 'Saved', detail: 'Your phone number was saved!', life: 1000
              });
              this.isPhoneProvided = true;
              this.phoneToVerify = this.newPhonePrefix + this.newPhoneNumber;
          }, (err) => {
              this.messageService.add({
                  key: 'globalToast',
                  severity: 'error',
                  summary: 'Error',
                  detail: `An error occurred saving your number`, life: 3000
              });
          });
  }

  showPhonePrefix() {
      return (this.newPhonePrefix) ? `(+${this.newPhonePrefix}) ` : '';
  }

  otpChanged(otpCode: string[]) {
      this.otpCode = otpCode;
  }

  isOtpCodeFilled() {
    return this.otpCode.length === 6 && this.otpCode.every(c => c !== '');
  }
}
